"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { captureException } from "@/lib/posthog-client";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    // Capture error in Sentry
    Sentry.captureException(error);
    // Also capture error in PostHog for correlation
    captureException(error, { digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-screen bg-background text-foreground">
        <div className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-6 text-center">
          <div className="mb-6 rounded-full border border-border/60 bg-muted/40 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            Something went wrong
          </div>
          <h1 className="text-3xl font-semibold sm:text-4xl">
            Sorry, we hit an unexpected error.
          </h1>
          <p className="mt-3 text-sm text-muted-foreground sm:text-base">
            Please return to the home page and try again. If the problem continues,
            restarting the process usually fixes it.
          </p>
          <div className="mt-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Button asChild size="lg">
                <Link href="/app">Back to App</Link>
              </Button>              
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
